import { Link } from 'react-router-dom';
import Hero from './components/Hero';
import LocationsSection from './components/LocationsSection';
import Footer from '../../../components/feature/Footer';

export default function BorderBurgerCoPage() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />

      <div className="max-w-[1400px] mx-auto px-6 py-16">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-zinc-900 mb-4">
            About The Border Burger Co.
          </h2>
          <p className="text-lg text-zinc-600 max-w-3xl mx-auto leading-relaxed">
            The Border Burger Co. elevates the classic American burger with gourmet toppings and creative flavor 
            combinations. We use premium beef, fresh vegetables, and house-made sauces to create signature burgers 
            that are anything but ordinary. From classic cheeseburgers to bold fusion creations, every burger is 
            cooked to perfection and served with our famous hand-cut fries in a family-friendly atmosphere.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          <div className="text-center p-8 bg-orange-50 rounded-2xl">
            <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-restaurant-2-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-zinc-900 mb-2">Signature Burgers</h3>
            <p className="text-zinc-600">Gourmet burgers with creative toppings and premium beef</p>
          </div>

          <div className="text-center p-8 bg-orange-50 rounded-2xl">
            <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-knife-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-zinc-900 mb-2">Hand-Cut Fries</h3>
            <p className="text-zinc-600">Fresh-cut fries made daily and seasoned to perfection</p>
          </div>

          <div className="text-center p-8 bg-orange-50 rounded-2xl">
            <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-team-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-zinc-900 mb-2">Family Friendly</h3>
            <p className="text-zinc-600">Welcoming atmosphere perfect for the whole family</p>
          </div>
        </div>

        {/* Locations */}
        <LocationsSection />
      </div>

      <section className="bg-gradient-to-br from-orange-500 to-orange-600 py-20">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold text-white mb-4">
            Visit The Border Burger Co. Today
          </h2>
          <p className="text-white/90 text-lg mb-8">
            Experience gourmet burgers with bold flavors and fresh ingredients
          </p>
          <Link
            to="/places-to-eat"
            className="inline-flex items-center gap-2 bg-white text-orange-600 px-8 py-4 rounded-full font-semibold hover:bg-orange-50 transition-colors whitespace-nowrap"
          >
            <i className="ri-arrow-left-line text-xl"></i>
            Back to All Restaurants
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
